// // import PropTypes from 'prop-types';
// // // @mui
// // import Box from '@mui/material/Box';
// // import Stack from '@mui/material/Stack';
// // // theme
// // import { hideScroll } from 'src/theme/css';
// // // hooks
// // import { NavSectionMini } from 'src/components/nav-section';
// // import Logo from 'src/components/logo';
// // //
// // import { HEADER, NAV } from '../config-layout';
// // import { useNavData } from './config-navigation';
// // import { NavToggleButton } from '../_common';

// // // ----------------------------------------------------------------------

// // export default function NavMini({sx}) {
// //   const navData = useNavData();

// //   return (
// //     <Box
// //       component="nav"
// //       sx={{
// //         flexShrink: { lg: 0 },
// //         width: { lg: NAV.W_MINI },
// //       }}
// //     >
// //       <NavToggleButton
// //         sx={{
// //           top: 38,
// //           left: NAV.W_MINI - 12,
// //         }}
// //       />

// //       <Stack
// //         sx={{
// //           pb: 2,
// //           bottom: 0,
// //           position: 'fixed',
// //           top: { lg: HEADER.H_DESKTOP },
// //           width: NAV.W_MINI,
// //           bgcolor: 'background.paper',
// //           borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
// //           ...hideScroll.x,
// //           ...hideScroll.y,
// //         }}
// //       >
// //         <NavSectionMini data={navData} sx={{ pt: 1.5 }} />
// //       </Stack>
// //     </Box>
// //   );
// // }
// // NavMini.propTypes = {
// //   sx: PropTypes.object,
// // };

// import PropTypes from 'prop-types';
// // @mui
// import Box from '@mui/material/Box';
// import Stack from '@mui/material/Stack';
// // theme
// import { hideScroll } from 'src/theme/css';
// // hooks
// import { NavSectionMini } from 'src/components/nav-section';
// //
// import { HEADER, NAV } from '../config-layout';
// import { useNavData } from './config-navigation';
// import { NavToggleButton } from '../_common';

// // ----------------------------------------------------------------------

// export default function NavMini({ sx }) {
//   const navData = useNavData();

//   return (
//     <Box
//       component="nav"
//       sx={{
//         flexShrink: { lg: 0 },
//         width: { lg: NAV.W_MINI },
//         ...sx,
//       }}
//     >
//       <NavToggleButton
//         sx={{
//           top: 38,
//           left: NAV.W_MINI - 12,
//         }}
//       />

//       <Stack
//         sx={{
//           pb: 2,
//           bottom: 0,
//           position: 'fixed',
//           top: { lg: HEADER.H_DESKTOP },
//           width: NAV.W_MINI,
//           bgcolor: 'background.paper',
//           borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,

//           ...hideScroll.x,
//           ...hideScroll.y,

//           // =========================================================
//           // MINI SIDEBAR - ICON ONLY
//           // =========================================================

//           // Hide common text elements
//           '& .MuiTypography-root': {
//             display: 'none !important',
//           },

//           // Hide text rendered as span
//           '& .MuiListItemButton-root > span': {
//             display: 'none !important',
//           },

//           // Hide text rendered inside Box
//           '& .MuiListItemButton-root > .MuiBox-root': {
//             display: 'none !important',
//           },

//           // Center everything
//           '& .MuiListItemButton-root': {
//             minHeight: 56,
//             width: '100%',
//             justifyContent: 'center',
//             alignItems: 'center',
//             px: 0,
//           },

//           // Icon
//           '& .MuiListItemIcon-root': {
//             minWidth: 0,
//             width: 24,
//             height: 24,
//             margin: 0,
//             justifyContent: 'center',
//           },

//           // SVG icons
//           '& .MuiListItemButton-root svg': {
//             width: 24,
//             height: 24,
//           },
//         }}
//       >
//         <NavSectionMini
//           data={navData}
//           sx={{
//             pt: 1.5,
//             width: '100%',
//           }}
//         />
//       </Stack>
//     </Box>
//   );
// }

// NavMini.propTypes = {
//   sx: PropTypes.object,
// };

import PropTypes from 'prop-types';

// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

// theme
import { hideScroll } from 'src/theme/css';

// components
import { NavSectionMini } from 'src/components/nav-section';
import { NavToggleButton } from '../_common';

// hooks
import { useNavData } from './config-navigation';

// config
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

export default function NavMini({ sx }) {
  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
        ...sx,
      }}
    >
      <NavToggleButton
        sx={{
          top: 38,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          bottom: 0,
          position: 'fixed',
          top: { lg: HEADER.H_DESKTOP },
          width: NAV.W_MINI,

          bgcolor: 'background.paper',

          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,

          ...hideScroll.x,
          ...hideScroll.y,
        }}
      >
        <NavSectionMini
          data={navData}
          sx={{
            pt: 1.5,
            width: '100%',
          }}
        />
      </Stack>
    </Box>
  );
}

NavMini.propTypes = {
  sx: PropTypes.object,
};
